import React, { Component } from "react";
import Express from "@Meridian-Developers/meridian-ui/middleware_controller";

export default class Flush extends Component {
    componentDidMount() {
        Express.callPublic("flush-all-store", {}, () => {
            window.location.href = "/";
        });
    }

    render() {
        return <div>flush all</div>;
    }
}
